import React, { useState, useContext, Fragment } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";
import { Redirect } from "react-router-dom";

// @material-ui/core components
import { makeStyles } from "@mui/styles";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { CreditScoreOutlined } from "@mui/icons-material";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import clsx from "clsx";
import { DataGrid, gridClasses } from "@mui/x-data-grid";
import axios from "axios";
import {
  Box,
  Grid,
  Alert,
  Typography,
  Dialog,
  DialogContent,
  DialogActions,
} from "@mui/material";
import Moment from "moment";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import LoadUserProfile from "components/services/LoadUserProfile";
import ExcelClientListReportOperators from "views/Print/ExcelClientListReportOperators";

import loaderGif from "assets/img/loading.gif";
import noDataImg from "assets/img/undraw_House_searching_re_stk8.png";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const infoStyle = {
  color: "#1d1d1b",
  fontSize: 10,
  fontWeight: "bold",
  margin: "3px 0",
  borderBottom: "1px solid #f2f2f2",
  paddingLeft: 2,
  padding: "2px 5px 2px 15px",
};

export default function ReportTransactionsOperatorList(props) {
  const classes = useStyles();

  const [toDate, setToDate] = useState();
  const [fromDate, setFromDate] = useState();
  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [loader, setLoader] = useState(false);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    userData: null,
  });

  const [state] = useState({
    columns: [
      {
        headerName: "COD.",
        field: "code",
        width: 60,
        headerAlign: "center",
        align: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <Alert severity="info" icon={false}>
              <b style={{ fontSize: 10 }}>{params.value} </b>
            </Alert>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Gestor",
        field: "user",
        flex: 1,
        headerAlign: "center",
        headerClassName: "super-app-theme--header",
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        renderCell: (params) => {
          return (
            <div style={{ whiteSpace: "normal" }}>
              {renderProfile(params.row)}
            </div>
          );
        },
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Cliente",
        field: "client.allNames",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <span style={{ fontSize: 12 }}>{params.row.client.allNames} </span>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        flex: 1,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Producto",
        field: "productsJson[0].name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          let caracteristicas = params.row.productsJson[0].prices.find(
            (data) => data.price === params.row.productsJson[0].priceSelect
          );

          return (
            <div style={{ width: "100%" }}>
              <b style={{ fontSize: 11 }}>{params.row.productsJson[0].name}</b>
              <br></br>
              <span style={{ fontSize: 10 }}>- {caracteristicas.name}</span>
              <br></br>
              <span style={{ fontSize: 10 }}>
                - {params.row.productsJson[0].periodo}
              </span>
            </div>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        width: 140,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Comisión $",
        field: "commissionPercentageUser",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          const commissionPercentage = parseFloat(
            params.row.commissionPercentageUser
          );
          const payTotal =
            params.row.productsJson[0].typePay === "CR"
              ? parseFloat(params.row.productsJson[0].payMonthTotal)
              : parseFloat(params.row.productsJson[0].payTotal);

          // Verificamos si ambos valores son números válidos
          if (isNaN(commissionPercentage) || isNaN(payTotal)) {
            return <span style={{ fontSize: 12 }}>0</span>; // Retorna 0 si los valores no son válidos
          }

          // Cálculo de la comisión
          const percentage = (commissionPercentage * payTotal) / 100;

          return (
            <b
              style={{
                fontSize: 12,
                padding: 4,
                background: "rgb(237, 247, 237)",
              }}
            >
              ${percentage.toFixed(2)}
            </b>
          ); // Mostrar el valor con dos decimales
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Total",
        field: "productsJson",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <b style={{ fontSize: 12 }}>
              {`$${
                params.row.productsJson[0].typePay === "CR"
                  ? params.row.productsJson[0].payMonthTotal
                  : params.row.productsJson[0].payTotal
              }`}
            </b>
          );
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 90,
        sortable: false,
        filtering: false,
        hideable: false,
      },
      {
        headerName: "Creación",
        field: "createdAt",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        renderCell: (params) => {
          return <span>{Moment(params.value).format("DD-MM-YYYY")} </span>;
        },
        cellClassName: (params) => {
          return clsx("super-app", {
            celAll: params.value,
          });
        },
        align: "center",
        width: 110,
        sortable: false,
        filtering: false,
        hideable: false,
      },
    ],
  });

  const handleFromDateChange = (data) => {
    setFromDate(data);

    // Si la nueva fecha "Desde" es mayor que "Hasta", restablece "Hasta"
    if (data && toDate && data.isAfter(toDate)) {
      setToDate(null);
    } else {
      setToDate(null);
    }
  };

  const handleToDateChange = (data) => {
    setToDate(data);
  };

  const renderProfile = (row) => (
    <>
      <Typography sx={infoStyle} style={{ fontSize: 12 }}>
        {row.user.allNames}
      </Typography>
      <Typography sx={infoStyle} style={{ fontWeight: 500 }}>
        ({row.user.profile.name})
      </Typography>
    </>
  );

  const handleResponseData = (data) => {
    return data.map((item) => ({
      ...item,
      productsJson: parseJsonArray(item.productsJson),
      dependentsJson: parseJsonArray(item.dependentsJson),
    }));
  };

  const RefreshTable = async () => {
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients-transaction/list/company`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        const transformedRows = handleResponseData(response.data);

        const responseData = transformedRows.filter(
          (client) =>
            client.paymentTransactions.length > 0 &&
            client.paymentTransactions.some(
              (transaction) => transaction.status === 1
            )
        );

        let filteredRows = responseData;

        const responseData1 = transformedRows.filter(
          (client) => client.cashPaymentTransactions.length > 0
        );

        filteredRows = [...filteredRows, ...responseData1];

        if (values.userData) {
          filteredRows = filteredRows.filter(
            (item) => item.userId === values.userData.id
          );
        }

        if (fromDate && toDate) {
          // Convertir las fechas de fromDate y toDate a formato 'YYYY-MM-DD'
          const fromDateValue = dayjs(fromDate).format("YYYY-MM-DD");
          const toDateValue = dayjs(toDate).format("YYYY-MM-DD");

          // Filtrar los registros por el rango de fechas
          filteredRows = filteredRows.filter((item) => {
            const createdAt = dayjs(item.createdAt).format("YYYY-MM-DD");

            // Verifica si createdAt está dentro del rango entre fromDate y toDate
            return createdAt >= fromDateValue && createdAt <= toDateValue;
          });
        }

        const responseDataFinal = filteredRows.filter(
          (client) => client.status === 1
        );

        setTotalRows(responseDataFinal.length);
        setRows(responseDataFinal);
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const changeUserProfile = (data) => {
    setValues((prevValues) => ({
      ...prevValues,
      userData: data || null,
    }));

    setRows(data ? rows : []);
    setTotalRows(data ? totalRows : 0);
  };

  const handleSearch = () => () => {
    RefreshTable();
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit();
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      aria-labelledby="customized-dialog-title"
      open={props.open}
      keepMounted
      scroll="body"
      PaperProps={{
        sx: {
          borderRadius: 6,
        },
      }}
    >
      <DialogContent dividers className={classes.styleDialogContent}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div className={classes.cardTitleBlack}>
              <CreditScoreOutlined className={classes.iconFilter} /> Reporte de
              transacciones pagadas
            </div>
            <Card>
              <CardBody>
                {error ? <Alert severity="error">{mensageSystem}</Alert> : ""}
                {loader ? (
                  <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                      <center>
                        <img
                          alt="loaderGif"
                          src={loaderGif}
                          style={{ width: 60, margin: "20% 0" }}
                        />
                      </center>
                    </Grid>
                  </Grid>
                ) : (
                  <Fragment>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12}>
                        <div
                          className={classes.cardTitleBlack}
                          style={{ fontSize: 14 }}
                        >
                          Filtros:
                        </div>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <LoadUserProfile
                          value={values.userData}
                          refresh={changeUserProfile}
                          style={{ marginBottom: 2 }}
                        />
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="fromDate"
                              label="Desde"
                              value={fromDate}
                              onChange={(newValue) =>
                                handleFromDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} md={3}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={["DatePicker"]}>
                            <DatePicker
                              name="toDate"
                              label="Hasta"
                              value={toDate}
                              onChange={(newValue) =>
                                handleToDateChange(newValue)
                              }
                              format="DD/MM/YYYY"
                              sx={{
                                "& .MuiButtonBase-root": {
                                  color: "#333",
                                },
                                width: "100%",
                                background: "#FFFFFF",
                              }}
                              slotProps={{
                                textField: {
                                  // helperText: "DD/MM/YYYY",
                                  //  required: true,
                                  size: "small",
                                },
                              }}
                              disabled={fromDate ? false : true}
                              minDate={fromDate ? fromDate : null}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <ButtonStyle0
                          style={{ fontSize: 12, width: 130, marginTop: 10 }}
                          onClick={handleSearch()}
                        >
                          {values.userData ? "Buscar filtro" : "Buscar todo"}
                        </ButtonStyle0>
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <Box style={{ float: "right" }}>
                          <span
                            className={classes.cardTitleBlack}
                            style={{ fontSize: 14, marginRight: 20 }}
                          >
                            Total registro{totalRows > 1 ? "s" : ""}:
                            {" " + totalRows}
                          </span>
                          <center>
                            <ExcelClientListReportOperators
                              excelData={rows}
                              fileName={`Exportar_excel_clientes_transaccion_operador`}
                              disabled={rows.length > 0 ? false : true}
                            />
                          </center>
                        </Box>
                      </Grid>
                    </Grid>
                    <Grid container>
                      {rows.length > 0 ? (
                        <Grid item xs={12} sm={12}>
                          <Box
                            sx={{
                              "& .super-app.celAll": {
                                fontSize: 12,
                                //backgroundColor: 'rgba(255, 7, 0, 0.55)',
                              },
                              "& .super-app.celActions": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              "& .super-app-theme--header": {
                                backgroundColor: "rgb(242, 242, 242)",
                              },
                              marginTop: 2,
                            }}
                          >
                            <DataGrid
                              rows={rows}
                              columns={state.columns}
                              loading={loader}
                              initialState={{
                                pagination: {
                                  paginationModel: { page: 0, pageSize: 100 },
                                },
                              }}
                              pageSizeOptions={[5, 10, 20, 100]}
                              disableRowSelectionOnClick={true}
                              checkboxSelection={false}
                              sx={{
                                [`& .${gridClasses.cell}`]: {
                                  display: "flex",
                                  alignItems: "center", // Alineación vertical
                                  // justifyContent: 'center', // Alineación horizontal
                                  wordWrap: "break-word !important",
                                  whiteSpace: "normal !important",
                                },
                                /* [`& .${gridClasses.columnHeaderTitle}`]: {
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                },*/
                              }}
                              getRowHeight={() => "auto"}
                              // autoHeights
                              autoWidth
                            />
                          </Box>
                        </Grid>
                      ) : (
                        <Grid item xs={12} sm={12}>
                          <center>
                            <img
                              alt="loaderGif"
                              src={noDataImg}
                              style={{ width: 300, marginTop: 50 }}
                            />
                            <br></br>
                            <b style={{ fontSize: 18, margin: "5px 0 70px 0" }}>
                              No hay registros para mostrar
                            </b>
                          </center>
                        </Grid>
                      )}
                    </Grid>
                  </Fragment>
                )}
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </DialogContent>
      <DialogActions>
        <ButtonExit onClick={handleCloseDialog()}>Cerrar</ButtonExit>
      </DialogActions>
    </Dialog>
  );
}
